/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Push_DeniedInputs */

const en_us2_profile_push_denied = /** @type {(inputs: Profile_Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android is blocking the app's notifications. Allow them in the device settings.`)
};

const pt_br2_profile_push_denied = /** @type {(inputs: Profile_Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Android bloqueou as notificações do app. Libere nas configurações do aparelho.`)
};

const es_419_profile_push_denied = /** @type {(inputs: Profile_Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android está bloqueando las notificaciones de la app. Permítelas en la configuración del dispositivo.`)
};

const pt_pt2_profile_push_denied = /** @type {(inputs: Profile_Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Android está a bloquear as notificações da app. Permite-as nas definições do dispositivo.`)
};

const fr_fr2_profile_push_denied = /** @type {(inputs: Profile_Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android bloque les notifications de l'app. Autorise-les dans les réglages de l'appareil.`)
};

const de_de2_profile_push_denied = /** @type {(inputs: Profile_Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android blockiert die Benachrichtigungen der App. Erlaube sie in den Geräteeinstellungen.`)
};

const it_it2_profile_push_denied = /** @type {(inputs: Profile_Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android sta bloccando le notifiche dell'app. Consentile nelle impostazioni del dispositivo.`)
};

/**
* | output |
* | --- |
* | "Android is blocking the app's notifications. Allow them in the device settings." |
*
* @param {Profile_Push_DeniedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_push_denied = /** @type {((inputs?: Profile_Push_DeniedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Push_DeniedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_push_denied(inputs)
	if (locale === "es-419") return es_419_profile_push_denied(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_push_denied(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_push_denied(inputs)
	if (locale === "de-DE") return de_de2_profile_push_denied(inputs)
	if (locale === "it-IT") return it_it2_profile_push_denied(inputs)
	return en_us2_profile_push_denied(inputs)
});
export { profile_push_denied as "profile.push_denied" }